// extracted by mini-css-extract-plugin
export var errorIcon = "_mk-1";
export var nameLogo = "_mk-0";